import { render, staticRenderFns } from "./InsuranceContractRecord.vue?vue&type=template&id=028aadff&scoped=true"
import script from "./InsuranceContractRecord.vue?vue&type=script&lang=js"
export * from "./InsuranceContractRecord.vue?vue&type=script&lang=js"
import style0 from "./InsuranceContractRecord.vue?vue&type=style&index=0&id=028aadff&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "028aadff",
  null
  
)

export default component.exports